import React from "react";
import { Section } from "../../../components/section";
import { SectionHeader } from "../../../components/section-header";
import { ScreenGroup } from "../../../components/screen-group";
import feed from "../../../images/Feed.png";
import details from "../../../images/Details.png";
import sources from "../../../images/Preferred-Sources.png";
import corrections from "../../../images/Corrections.png";
import accounts from "../../../images/Accounts.png";
import credilibty from "../../../images/Feed-Credibility.png";

export interface ISolutionProps {
    sectionId: string;
    index: number;
}

export function Solution(props: ISolutionProps) {
    const formattedIndex = props.index > 10 ? props.index : `0${props.index}`;
    return (
        <Section
            sectionId={props.sectionId}
            isLast={false}
        >
            <SectionHeader
                title={`${formattedIndex} Solution`}
            />
            <ScreenGroup
                title="Fact-Checker"
                chips={["Quick Evaluation"]}
                description="The Fact-Checker identifies claims and provides a summary of the facts to help platforms users quickly evaluate content credibility at different levels of depth."
                features={
                    [
                        {
                            imgSrc: feed,
                            title: "Fact-check Indicators",
                            body: "Helps users quickly identify the credibility of claims in-feed"
                        },
                        {
                            imgSrc: details,
                            title: "Fact-check Details",
                            body: "Pulls forward evidence from reputable sources to support the verdict"
                        },
                        {
                            imgSrc: sources,
                            title: "Preferred Sources",
                            body: "Takes user preferences into account when compiling facts and resources for fact-check details"
                        },
                        
                    ]
                }
            />
            <ScreenGroup
                startGoofy={true}
                title="Engagement Hub"
                chips={["Quick Evaluation", "Self-Reflection"]}
                description="The Engagement Hub houses features and user engagement trends that support users in taking action against misinformation."
                features={
                    [
                        {
                            imgSrc: corrections,
                            title: "Corrections",
                            body: `Provides updates on fact-check verdicts to help users keep up with changing information`
                        },
                        {
                            imgSrc: accounts,
                            title: "Accounts to Review",
                            body: "Surfaces accounts that post the highest proportion of misinformation in content users have engaged with"
                        },
                        {
                            imgSrc: credilibty,
                            title: "Feed Settings",
                            body: "Gives users options to control the visibility of misinformation in their feeds"
                        },
                        
                    ]
                }
            />
        </Section>
    );
}
